var download = require('downloadjs');
import moment from 'moment';
import * as apiHelper from '../../../apiHelper';

import { pushError, popError } from '../../global/actions';

const controller = 'reports';

export function generateYIRReport(d, cb) {
  return (dispatch, getState) => {
    let state = getState();
    dispatch(popError('yirerror'));
    return apiHelper.apiPost(controller, d, state.Global.token, 'owner_yir')
      .then(response => {
        if (response.status === 200) {
          return response.blob();
        } else {
          dispatch(pushError({ errType: 'yirerror', message: 'A server error occurred. The report could not be generated.' }))
          cb();
          return null;
        }
      })
      .then(body => {
        if (body) { download(body, `Owner Reports (${moment(d.dates.from).format("M/D/Y")}-${moment(d.dates.to).format("M/D/Y")}).csv`, "application/octet-stream"); }
        cb();
      });
  }
}
